import React from "react";
import ConnectionsDashboard from "../components/ConnectionsDashboard";

function ConnectionsDashboardPage() {
    return (
      <>
        <ConnectionsDashboard />
      </>
    );
  };
  
export default ConnectionsDashboardPage;
